import { render, staticRenderFns } from "./developer.vue?vue&type=template&id=32c28179&"
import script from "./developer.vue?vue&type=script&lang=js&"
export * from "./developer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports